import { Grid, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { MdGroupAdd, MdLibraryAdd, MdPeople } from 'react-icons/md';
import { icon_account, icon_addMenuArcheive, icon_addMenuItem, icon_booking_list, icon_checkIn, icon_dashboard, icon_invoices, icon_onboarding, icon_optionTimes, icon_priceModel, icon_profile, icon_upcoming, icon_upcomingMenus } from '../../../assets/images/images';
import { Logo } from '../../../components/ui/Logo';

interface Props { 
    sideBarItemSelected ?: string;
    setSideBarItemSelected: React.Dispatch<React.SetStateAction<any>>;
}

const useStyles = makeStyles((theme: any) => ({
    sidebarContainer: {
        position: 'fixed',
        width: 210,
        overflow: 'hidden',
        height: '100vh',
        top: 0,
        left: 0,
        bottom: 0,
        backgroundColor: '#1E1151',
        paddingTop: 28
    },
    sidebarLunchBooking:{
        fontSize: 10,
        fontWeight: 400,
        color: '#FFFFFF'
    },
    sidebarCompanyName:{
        fontSize: 16,
        fontWeight: 700,
        color: '#FFFFFF'
    },
    adminSidebarLogoFlexContainer:{
        paddingLeft: 30,
        display:'flex',
        alignItems: 'center',
        justifyContent: 'start',
        float: 'left',
    },
    adminSidebarLogoContainer:{
        cursor: 'pointer',
        display:'block',
        paddingBottom: 105
    },
    adminSidebarTitlesContainer:{
        marginLeft: 12,
        width: '100%',
        float: 'left',
    },
    sidebarMenuItemContainer:{
        display: 'grid',
        gridTemplateColumns: "20% 80%",

        justifyContent: 'flex-start',
        alignItems: 'center',

        paddingLeft: 30,
        width: '100%',
        height: 30,

        color: 'rgba(255, 255, 255, 0.5);',
        fontSize: 12,
        fontWeight: 700,

        cursor: 'pointer',
    },
    sidebarMenuItemLogoContainer:{
        paddingRight: 13,
        color: "white !important",
    },
    sidebarCategoryContainer:{
        paddingTop: 32
    },
     sidebarCategoryTitle:{
        fontSize: 11,
        fontWeight: 700,
        color: 'rgba(255, 255, 255, 0.3);',
        paddingLeft: 30,
        paddingBottom: 5
    },
    logo: {
        height: 24,
        width: 32
    }
}));

export const SideBar: React.FC<Props> = ({sideBarItemSelected,setSideBarItemSelected}) => {
    const classes = useStyles();

    const selectedColor : string = '#FFFFFF';
    const notSelectedColor : string = 'rgba(255, 255, 255, 0.5)';
    const selectedStyle = {
        background: 'rgba(255, 255, 255, 0.1)',
        color: selectedColor,
    }

    const notSelectedStyle = {
        background: 'none',
        color: notSelectedColor,
    }

    const selectedStyleLogo = {
        opacity: 1
    }

    const notSelectedStyleLogo = {
        opacity: 0.3
    }

    const updateSelectedDates = (sideBarItemClicked: string) => {
        setSideBarItemSelected(sideBarItemClicked);
    }

    return (
        <div className={classes.sidebarContainer}>
            <div className={classes.adminSidebarLogoContainer} onClick={() => updateSelectedDates('/admin/dashboard')}>
                <div className={classes.adminSidebarLogoFlexContainer}>
                    <Logo variant='small_white' />
                    <div className={classes.adminSidebarTitlesContainer}>
                        <div className={classes.sidebarCompanyName}> 
                            PlanEat
                        </div>
                        <div className={classes.sidebarLunchBooking}>
                            Lunch Booking
                        </div>
                    </div>
                </div>
            </div>
            
            <div className={classes.sidebarMenuItemContainer} style={sideBarItemSelected=== '/admin/dashboard' ? selectedStyle : notSelectedStyle} onClick={() => updateSelectedDates('/admin/dashboard')}>
                <img src={icon_dashboard} alt="/admin/dashboard" className={classes.sidebarMenuItemLogoContainer} style={sideBarItemSelected=== '/admin/dashboard' ? selectedStyleLogo : notSelectedStyleLogo}/>
                <div>Dashboard</div>
            </div>
            <div className={classes.sidebarCategoryContainer}>
                <div className={classes.sidebarCategoryTitle}>
                    Bookings
                </div>
                <div className={classes.sidebarMenuItemContainer} style={sideBarItemSelected=== '/admin/bookings' ? selectedStyle : notSelectedStyle} onClick={() => updateSelectedDates('/admin/bookings')}>
                    <img src={icon_booking_list} alt="/admin/bookings" className={clsx(classes.sidebarMenuItemLogoContainer,classes.logo)} style={sideBarItemSelected=== '/admin/bookings' ? selectedStyleLogo : notSelectedStyleLogo}/>
                    <div>Bookings</div>
                </div>
                <div className={classes.sidebarMenuItemContainer} style={sideBarItemSelected=== '/admin/checkIn' ? selectedStyle : notSelectedStyle} onClick={() => updateSelectedDates('/admin/checkIn')}>
                    <img src={icon_checkIn} alt="/admin/checkIn" className={classes.sidebarMenuItemLogoContainer} style={sideBarItemSelected=== '/admin/checkIn' ? selectedStyleLogo : notSelectedStyleLogo}/>
                    <div>Check-in</div>
                </div>
                <div className={classes.sidebarMenuItemContainer} style={sideBarItemSelected=== '/admin/upcoming' ? selectedStyle : notSelectedStyle} onClick={() => updateSelectedDates('/admin/upcoming')}>
                    <img src={icon_upcoming} alt="/admin/upcoming" className={classes.sidebarMenuItemLogoContainer} style={sideBarItemSelected=== '/admin/upcoming' ? selectedStyleLogo : notSelectedStyleLogo}/>
                    <div>Upcoming</div>
                </div>
            </div>
            <div className={classes.sidebarCategoryContainer}>
                <div className={classes.sidebarCategoryTitle}>
                    Menus
                </div>
                <div hidden={true} className={classes.sidebarMenuItemContainer} style={sideBarItemSelected=== '/admin/addMenuItem' ? selectedStyle : notSelectedStyle}  onClick={() => updateSelectedDates('/admin/addMenuItem')}> 
                    <img src={icon_addMenuItem} alt="/admin/addMenuItem" className={classes.sidebarMenuItemLogoContainer} style={sideBarItemSelected=== '/admin/addMenuItem' ? selectedStyleLogo : notSelectedStyleLogo}/>
                    <div>Add Menu Item</div>
                </div>
                <div className={classes.sidebarMenuItemContainer} style={sideBarItemSelected=== '/admin/addItemArcheive' ? selectedStyle : notSelectedStyle}  onClick={() => updateSelectedDates('/admin/addItemArcheive')}>
                    <img src={icon_addMenuArcheive} alt="/admin/addItemArcheive" className={classes.sidebarMenuItemLogoContainer} style={sideBarItemSelected=== '/admin/addItemArcheive' ? selectedStyleLogo : notSelectedStyleLogo}/>
                    <div>Menu</div>
                </div>
                <div  hidden={true} className={classes.sidebarMenuItemContainer} style={sideBarItemSelected=== '/admin/upcomingMenus' ? selectedStyle : notSelectedStyle}  onClick={() => updateSelectedDates('/admin/upcomingMenus')}>
                    <img src={icon_upcomingMenus} alt="/admin/upcomingMenus" className={classes.sidebarMenuItemLogoContainer} style={sideBarItemSelected=== '/admin/upcomingMenus' ? selectedStyleLogo : notSelectedStyleLogo}/>
                    <div>Upcoming Menus</div>
                </div>
            </div>
            <div className={classes.sidebarCategoryContainer}>
                <div className={classes.sidebarCategoryTitle}>
                    Cafeteria
                </div>
                <div className={classes.sidebarMenuItemContainer} style={sideBarItemSelected=== '/admin/optionsTimes' ? selectedStyle : notSelectedStyle}  onClick={() => updateSelectedDates('/admin/optionsTimes')}>
                    <img src={icon_optionTimes} alt="/admin/optionsTimes" className={classes.sidebarMenuItemLogoContainer} style={sideBarItemSelected=== '/admin/optionsTimes' ? selectedStyleLogo : notSelectedStyleLogo}/>
                    <div>Seatings</div>
                </div>
                <div className={classes.sidebarMenuItemContainer} style={sideBarItemSelected=== '/admin/priceModels' ? selectedStyle : notSelectedStyle}  onClick={() => updateSelectedDates('/admin/priceModels')}>
                    <img src={icon_priceModel} className={classes.sidebarMenuItemLogoContainer} style={sideBarItemSelected=== '/admin/priceModels' ? selectedStyleLogo : notSelectedStyleLogo}/>
                    <div>Price Models</div>
                </div>
            </div>
            <div className={classes.sidebarCategoryContainer}>
                <div className={classes.sidebarCategoryTitle}>
                    Settings
                </div>
                <div className={classes.sidebarMenuItemContainer} style={sideBarItemSelected=== '/admin/profile' ? selectedStyle : notSelectedStyle}  onClick={() => updateSelectedDates('/admin/profile')}>
                    <img src={icon_profile} alt="/admin/profile" className={classes.sidebarMenuItemLogoContainer} style={sideBarItemSelected=== '/admin/profile' ? selectedStyleLogo : notSelectedStyleLogo}/>
                    <div>Profile</div>
                </div>
                <div className={classes.sidebarMenuItemContainer} style={sideBarItemSelected=== '/admin/account' ? selectedStyle : notSelectedStyle}  onClick={() => updateSelectedDates('/admin/account')}>
                    <img src={icon_account} alt="/admin/account" className={classes.sidebarMenuItemLogoContainer} style={sideBarItemSelected=== '/admin/account' ? selectedStyleLogo : notSelectedStyleLogo}/>
                    <div>Account</div>
                </div>
                <div className={classes.sidebarMenuItemContainer} style={sideBarItemSelected=== '/admin/invoices' ? selectedStyle : notSelectedStyle}  onClick={() => updateSelectedDates('/admin/invoices')}>
                    <img src={icon_invoices} alt="/admin/invoices" className={classes.sidebarMenuItemLogoContainer} style={sideBarItemSelected=== '/admin/invoices' ? selectedStyleLogo : notSelectedStyleLogo}/>
                    <div>Invoices</div>
                </div>
            </div>
            <div className={classes.sidebarCategoryContainer}>
                <div className={classes.sidebarCategoryTitle}>
                    Onboarding
                </div>
                <div className={classes.sidebarMenuItemContainer} style={sideBarItemSelected=== '/admin/users' ? selectedStyle : notSelectedStyle}  onClick={() => updateSelectedDates('/admin/users')}>
                    <MdPeople color="white" size={18} style={sideBarItemSelected=== '/admin/users' ? selectedStyleLogo : notSelectedStyleLogo}/>
                    <div>Users</div>
                </div>
                <div className={classes.sidebarMenuItemContainer} style={sideBarItemSelected=== '/admin/onboarding' ? selectedStyle : notSelectedStyle}  onClick={() => updateSelectedDates('/admin/onboarding')}>
                    <MdLibraryAdd color="white" size={18} style={sideBarItemSelected=== '/admin/onboarding' ? selectedStyleLogo : notSelectedStyleLogo}/>
                    <div>Onboarding</div>
                </div>
            </div>
        </div>
    );
}


